export type MentionUsersRefreshResult<T> = T[] | Promise<T[] | null | undefined> | null | undefined

export const createMentionUserSource = <T>(
    getUsers: () => T[],
    refreshUsers?: () => MentionUsersRefreshResult<T>,
    onUsersRefreshed?: (users: T[]) => void,
) => {
    let refreshedUsers: T[] | null = null
    let activeRefresh: Promise<void> | null = null

    const updateRefreshedUsers = (users: T[] | null | undefined) => {
        const nextUsers = Array.isArray(users) ? users : getUsers()
        if (nextUsers === refreshedUsers) return

        refreshedUsers = nextUsers
        onUsersRefreshed?.(nextUsers)
    }

    const startRefresh = () => {
        if (!refreshUsers || activeRefresh) return

        let refreshResult: MentionUsersRefreshResult<T>
        try {
            refreshResult = refreshUsers()
        } catch (error) {
            console.error('[MentionSuggestion] Failed to refresh users:', error)
            updateRefreshedUsers(null)
            return
        }

        if (Array.isArray(refreshResult)) {
            updateRefreshedUsers(refreshResult)
            return
        }
        if (!refreshResult) {
            updateRefreshedUsers(null)
            return
        }

        const refreshPromise = Promise.resolve(refreshResult)
            .then(users => {
                updateRefreshedUsers(users)
            })
            .catch(error => {
                console.error('[MentionSuggestion] Failed to refresh users:', error)
                updateRefreshedUsers(null)
            })
            .finally(() => {
                if (activeRefresh === refreshPromise) activeRefresh = null
            })

        activeRefresh = refreshPromise
    }

    return () => {
        startRefresh()
        return refreshedUsers || getUsers()
    }
}
